// ============================
// File: src/features/triage/api/triageClient.js
// ============================
//
// Triage was one of only two stages that reached the backend, but it still had a
// `fakeBedrockTriage` fallback that produced a *plausible score and gap list* from
// client-side heuristics whenever the server returned 5xx — and the UI displayed
// that as the AI verdict. A fabricated triage score is worse than an error, so the
// fallback is gone and failures propagate.
//
// Also removed:
//   - `import { API, Storage } from "aws-amplify"` — never used, and it pulled the
//     whole Amplify SDK into the triage bundle.
//   - getItpmAiReview / getItpmAiReviewAxios — unreferenced, and both built
//     `${BASE}/api/ai_review/...` which resolved to /api/api/ai_review/... anyway.
//   - writeDemandStatus / putTriageReport — POSTs to endpoints that do not exist.
//     POST /demands/{id}/triage/run already persists triage_pass, triage_score,
//     gap_list and the stage transition server-side, so these were duplicating a
//     write that had already happened, then swallowing their own 404s.

import { post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/**
 * Run AI triage validation.
 *
 * The server persists the result and moves the demand's stage, so there is nothing
 * for the caller to write afterwards.
 * -> { success, demand_id, triage_result: { triage_pass, triage_score, gap_list, summary, recommendations } }
 */
export async function runTriageValidate(demandId, payload) {
  return post(demandPath(demandId, "/triage/run"), payload, { timeout: AI_TIMEOUT_MS });
}

/**
 * Return the demand to its submitter with a gap list.
 * Creates one ClarifyBot task per gap. -> { gap_count, task_ids }
 */
export async function returnToSubmitter(demandId, payload) {
  return post(demandPath(demandId, "/triage/return-to-submitter"), payload);
}
